// src/lib/analytics.ts

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

export const initializeAnalytics = (consentGiven: boolean) => {
    if (!consentGiven) {
        return;
    }

    // Check if script is already loaded
    if (document.getElementById('google-analytics-script')) {
        return;
    }

    // Load GA4 script
    const script = document.createElement('script');
    script.id = 'google-analytics-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-34MX9CKQVY`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'G-34MX9CKQVY', {
        anonymize_ip: true, // GDPR requirement
        cookie_flags: 'SameSite=None;Secure'
        // debug_mode removed for production
    });
};

export const sendPageView = (path: string) => {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
        page_path: path,
        page_title: document.title
    });
};

export const disableAnalytics = () => {
    const script = document.getElementById('google-analytics-script');
    if (script) script.remove();

    // Clear cookies if possible (client-side clearing is limited for httpOnly/secure cookies)
    // This is a best-effort cleanup
    document.cookie.split(';').forEach(c => {
        if (c.trim().startsWith('_ga')) {
            document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
        }
    });

    // Note: We cannot easily "un-initialize" the dataLayer or gtag function without potentially breaking other things if they were shared,
    // but removing the script stops future tracking hits from being sent by the library.
};
